<template>
	<div id="app">
		<!-- 回到顶部 -->
		<el-backtop :right="5" :bottom="20">
			<!-- <i class="el-icon-caret-top"></i> -->
		</el-backtop>
		<!-- 右侧联系方式 -->
		<Contact></Contact>
		<!-- 页头 -->
		<Header></Header>
		<!-- 新闻详情 -->
		<NewsDetail v-if="isDetail"></NewsDetail>
		<!-- 新闻列表 -->
		<NewsList v-else></NewsList>
		<!-- 页脚 -->
		<Footer></Footer>
	</div>
</template>

<script>
	//引入组件
	import Contact from '../../components/Contact.vue';
	import Header from '../../components/Header.vue';
	import NewsList from '../../views/NewsList.vue';
	import NewsDetail from '../../views/NewsDetail.vue';
	import Footer from '../../components/Footer.vue';
	export default {
		name: 'NewsApp',
		components: {
			Contact,
			Header,
			NewsList,
			NewsDetail,
			Footer
		},
		data() {
			return {
				isDetail: false //是否详情页		 false:列表页  true:详情页
			}
		},
		created: function() {
			//如果传有新闻id
			if (location.href.indexOf("?newsid=") != -1) {
				this.isDetail = true;
			}
		},
		//不能用这种写法，会报错
		// created: () => {},
		mounted: () => {
			window.onload = function() {
				const arrAto = location.href.match(/\#\S+/gi);
				if (!arrAto || arrAto.length == 0) {
					//页面刷新滚动条重回顶部
					window.setTimeout(function() {
						document.body.scrollTop = 0;
						document.documentElement.scrollTop = 0;
						window.scrollTo(0, 0);
					}, 500);
				} else {
					$('html, body').animate({
						scrollTop: $(arrAto[0]).offset().top
					}, 500)
				}
			};
		}
	}
</script>

<style>
	#app {
		background-color: #000;
		color: #fff;
	}
</style>
